import useAuthenticatedApi from '../../Authentication/components/hooks/useAuthenticatedApi';

interface DeviceInviteActionsProps {
    orgId: number;
    row: any;
    onDelete: () => void;
}

export default function DeviceInviteActions({
    orgId,
    row,
    onDelete,
}: DeviceInviteActionsProps) {
    const deviceKeyId = row.original.id;
    const authenticatedApi = useAuthenticatedApi();

    const performDelete = () => {
        const deleteRequest = async () => {
            const response = await authenticatedApi.delete(
                `${orgId}/device-invites/${deviceKeyId}`,
            );

            if (response.status === 200) {
                onDelete();
            }
        };

        const shouldDelete = window.confirm(
            `Are you sure you would like to delete ${row.original.name}`,
        );

        if (shouldDelete) {
            deleteRequest();
        }
    };
    return (
        <span className="Table-options">
            <i onClick={performDelete} className="bi bi-trash3-fill"></i>
        </span>
    );
}
